import { createSelector } from 'reselect';
import { name, initialState } from './slice';

const selectAuth = (state) => state[name] || initialState;

export const authTokenSelector = (state) => state[name].sessionToken;

export const authProfile = (state) => (state[name] || initialState).profile;

export const authGeocodeParametersSelector = (state) =>
  state[name].profile.geocode;

export const authPaquerypointSelector = (state) =>
  (state[name].profile || {}).paquerypoint;

const makeSelectAuth = () => createSelector(selectAuth, (substate) => substate);

export default makeSelectAuth;
